<h1 *ngIf="!isLoaded && !error" class="px-2 mx-auto">Loading...</h1>
<h1 *ngIf="error" class="px-2 mx-auto text-red-500">{{ error.toString() }}</h1>

<section *ngIf="isLoaded" class="flex flex-row flex-wrap max-w-full pt-2 pl-2 pr-2 full-hd:pr-0 full-hd:flex-nowrap">
  <div class="w-full mb-2 lg:hidden">
    <app-sector-header [x]="selected.x" [y]="selected.y" [scan]="currentScan" (sectorSubmit)="onSectorSubmit($event)"></app-sector-header>
  </div>
  
  <div class="overflow-auto">
    <app-starmap [center]="center" [fields]="fields" [scans]="scans" (mapClick)="onMapClick($event)"></app-starmap>
  </div>

  <div class="flex-grow mt-2 lg:mt-0 lg:mx-2">
    <div class="hidden lg:block lg:mb-2">
      <app-sector-header [x]="selected.x" [y]="selected.y" [scan]="currentScan" (sectorSubmit)="onSectorSubmit($event)"></app-sector-header>
    </div>
    <app-sector-details [scan]="currentScan"></app-sector-details>
  </div>
</section>
